var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-button-type"},_vm._l((_vm.presets),function(preset,index){return _c('btn-button-type',{key:`type-${index}`,attrs:{"preset":preset},model:{value:(_vm.currentButtonType),callback:function ($$v) {_vm.currentButtonType=$$v},expression:"currentButtonType"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }